import { render, staticRenderFns } from "./teacher_profile.vue?vue&type=template&id=d5f51db0&"
import script from "./teacher_profile.vue?vue&type=script&lang=js&"
export * from "./teacher_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports